import { Typography } from "@mui/material";

const DataUnavailable = ({ message = "Onvoldoende data beschikbaar"}) => {
    return (<Typography color='gray' sx={{opacity:'0.5'}} variant="h2" textAlign='center'>{message}</Typography>)
};

export default DataUnavailable;